import { GPTGameButton } from './GPTGameButton';
import { GptGameButtonProps } from '../types';
import { GPTGameLauncher } from 'src/EXPERIMENTAL_LIB/modules/gpt/games';
import { useAuthFlow } from 'src/modules/authFlow/hooks/useAuthFlow';
import { VendingEventIcon } from './GPTEventIcons/VendingEventIcon';

export const VendingMachineButton = ({ isCollapsed, isEventActive }: GptGameButtonProps) => {
  const { startRegistration } = useAuthFlow();

  return (
    <GPTGameLauncher
      gameName="vendingMachine"
      renderButton={({ Icon, ...props }) => (
        <GPTGameButton
          {...props}
          isCompact={isCollapsed}
          Icon={isEventActive ? VendingEventIcon : Icon}
        />
      )}
      openRegistration={() => startRegistration()}
    />
  );
};
